import type { ResourceProps } from 'react-admin';
import AltRouteIcon from '@mui/icons-material/AltRoute';

import ShopifyRedirectsList from './ShopifyRedirectsList';
import ShopifyRedirectsShow from './ShopifyRedirectsShow';

export { shopifyRedirectsDataProvider } from './dataProvider';
export type { ShopifyProductRedirect } from './types';

const resource: ResourceProps = {
  name: 'shopify-redirects',
  list: ShopifyRedirectsList,
  show: ShopifyRedirectsShow,
  icon: AltRouteIcon,
  options: { label: 'Shopify Redirects' },
};

export default resource;
